import { render, staticRenderFns } from "./CarriersModalList.vue?vue&type=template&id=544beafd&scoped=true"
import script from "./CarriersModalList.vue?vue&type=script&lang=js"
export * from "./CarriersModalList.vue?vue&type=script&lang=js"
import style0 from "./CarriersModalList.vue?vue&type=style&index=0&id=544beafd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544beafd",
  null
  
)

export default component.exports